// extracted by mini-css-extract-plugin
export default {"products":"oy-z","card":"py-z","oosMessaging":"qy-z"};